import React, { useState } from 'react';
import { Pressable } from '~/components/gluestack/pressable';
import { Text } from '~/components/gluestack/text';
import { ContextSheet } from '~/components/ui/ContextSheet';
import { MemberListSheet } from './MemberListSheet';
import { useFormatCount } from '@/hooks/useFormatCount';
import { Member } from '@/models/Member';

interface MemberCountLinkProps {
  count: number;
  label: string;
  sheetTitle: string;
  listType: 'followers' | 'following';
  memberId: number;
}

export function MemberCountLink({ count, label, sheetTitle, listType, memberId }: MemberCountLinkProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { formatCount } = useFormatCount();

  return (
    <>
      <Pressable onPress={() => setIsOpen(true)} hitSlop={10}>
        <Text size="sm" className="text-typography-700 web:hover:underline">
          <Text className="font-bold">{formatCount(count)}</Text>
          {' '}
          <Text className="font-normal">{label}</Text>
        </Text>
      </Pressable>
      <ContextSheet
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        contentComponent={MemberListSheet}
        title={sheetTitle}
        payload={{
          listType,
          member: { Id: memberId } as Member,
        }}
      />
    </>
  );
}
